import React, { Fragment, useState, useEffect } from 'react'
import {Nav, Navbar, Row, Col} from 'react-bootstrap'
  
function Header() {

  const [ruta, setRuta] = useState('')

  const [blueC, setBlueC] = useState(false)
  const [blackC, setBlackC] = useState(false)

  useEffect(() => {
    setRuta(window.location.pathname)
  }, []);

  useEffect(() => {
    console.log(ruta);
    if(ruta === "/we"){
      document.getElementById("mwe1").classList.add("fw-blue")
      setBlackC(true)
      window.addEventListener("load", function(e) {
        let cambiarBtn = document.getElementById("socialButton").style.backgroundColor= "#161616"
        e.returnValue = cambiarBtn;
      });
      window.addEventListener("load", function(e) {
        document.getElementById("logoImg")
        let cambiarBg = document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:#161616; border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo_light.svg" alt="" class="imgLogo" style="max-width:140px; width:100%; className="imgLogo"/></a>'
        e.returnValue = cambiarBg;
      });
    } else if(ruta === "/users"){
      document.getElementById("musers1").classList.add("fw-blue")
    } else if(ruta === "/company"){
      document.getElementById("mcompany1").classList.add("fw-blue")
    }
  }, [ruta]);
  

const isElementXPercentInViewport = function(el, percentVisible) {
  if(el !== null){
    let rect = el.getBoundingClientRect(),
    windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  
    return !(
      Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-(rect.height / 1)) * 100)) < percentVisible ||
      Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
    )
  }
  
};

function isInViewport(element) {
  var rect = element.getBoundingClientRect();
  var html = document.documentElement;
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || html.clientHeight) &&
      rect.right <= (window.innerWidth || html.clientWidth)
  );
}

  document.addEventListener("scroll", ()=>{
    var scrolled = document.scrollingElement.scrollTop;
    //console.log("scrolled", scrolled);
    if(ruta === "/we"){
      // document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:#161616; border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo_light.svg" alt="" class="imgLogo" style="max-width:140px; width:100%; className="imgLogo"/></a>'
      // document.getElementById("socialButton").style.backgroundColor= "#161616";
      //WE 
      let ele1 = document.getElementById("dicio-about").getBoundingClientRect().top;//N
      let ele2 = document.getElementById("dicio-business").getBoundingClientRect().top;//B
      let ele3 = document.getElementById("dicio-team").getBoundingClientRect().top;//N
      if(ele1 >= 0 ){//n
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:#161616; border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo_light.svg" alt="" class="imgLogo" style="max-width:140px; width:100%; className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#161616";
        console.log('Element1 is ' + ele1);
        setBlackC(true)
        document.getElementById("mwe1").classList.add("fw-blue")
        document.getElementById("mwe2").classList.remove("fw-blue")
        document.getElementById("mwe3").classList.remove("fw-blue")
        document.getElementById("mwe4").classList.remove("fw-blue")
      }
      if(ele2 >= 0 && ele2 < 10){//b
        console.log('Element2 is ' + ele2);
        setBlackC(false)
        document.getElementById("mwe1").classList.remove("fw-blue")
        document.getElementById("mwe2").classList.add("fw-blue")
        document.getElementById("mwe3").classList.remove("fw-blue")
        document.getElementById("mwe4").classList.remove("fw-blue")
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:rgba(255, 255, 255, 0.95); border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo-4ac.svg" alt="" style="max-width:140px; width:100%; class="imgLogo"  className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "white";
      }else if(ele2>50 && ele2<60){
        setBlackC(true)
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:#161616; border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo_light.svg" alt="" class="imgLogo" style="max-width:140px; width:100%; className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#161616";
      }
      if(ele3 >= 0 && ele3 < 10){//n
        console.log('Element3 is ' + ele3);
        setBlackC(true)
        document.getElementById("mwe1").classList.remove("fw-blue")
        document.getElementById("mwe2").classList.remove("fw-blue")
        document.getElementById("mwe3").classList.add("fw-blue")
        document.getElementById("mwe4").classList.remove("fw-blue")
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:#161616; border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo_light.svg" alt="" class="imgLogo" style="max-width:140px; width:100%; className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#161616";
      }
      else if(ele3>50 && ele3<60){
        setBlackC(false)
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:rgba(255, 255, 255, 0.95); border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo-4ac.svg" alt="" style="max-width:140px; width:100%; class="imgLogo"  className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "white";
      }
      let eleC = document.getElementById("contact").getBoundingClientRect().top;//N
      if(eleC >= 0 && eleC < 10){//negro
        console.log('Element is ' + "contact");
        setBlackC(true)
        document.getElementById("mwe1").classList.remove("fw-blue")
        document.getElementById("mwe2").classList.remove("fw-blue")
        document.getElementById("mwe3").classList.remove("fw-blue")
        document.getElementById("mwe4").classList.add("fw-blue")
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:rgba(255, 255, 255, 0.95); border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo-4ac.svg" alt="" style="max-width:140px; width:100%; class="imgLogo"  className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "white";
      }else if(eleC>50 && eleC<60) {
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:#161616; border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo_light.svg" alt="" class="imgLogo" style="max-width:140px; width:100%; className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#161616";
      }
    }else if(ruta === "/users"){
      //USERS 
      let ele1 = document.getElementById("users-features").getBoundingClientRect().top;
      let ele2 = document.getElementById("users-about").getBoundingClientRect().top;
      let ele3 = document.getElementById("users-testimonial").getBoundingClientRect().top;
      let ele4 = document.getElementById("users-appContainer").getBoundingClientRect().top;
      if(ele1 === 0 ){//b
        console.log('Element1 is ' + ele1);
        setBlackC(false)
        document.getElementById("musers1").classList.add("fw-blue")
        document.getElementById("musers2").classList.remove("fw-blue")
        document.getElementById("musers3").classList.remove("fw-blue")
        document.getElementById("musers4").classList.remove("fw-blue")
        document.getElementById("musers5").classList.remove("fw-blue")
      }
      if(ele2 >= 0 && ele2 < 10){//n
        console.log('Element2 is ' + ele2);
        setBlackC(true)
        document.getElementById("musers1").classList.remove("fw-blue")
        document.getElementById("musers2").classList.add("fw-blue")
        document.getElementById("musers3").classList.remove("fw-blue")
        document.getElementById("musers4").classList.remove("fw-blue")
        document.getElementById("musers5").classList.remove("fw-blue")
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:#161616; border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo_light.svg" alt="" class="imgLogo" style="max-width:140px; width:100%; className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#161616";
      }else if(ele2>50 && ele2<60){
        setBlackC(false)
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:rgba(255, 255, 255, 0.95); border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo-4ac.svg" alt="" style="max-width:140px; width:100%; class="imgLogo"  className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "white";
      }
      if(ele3 >= 0 && ele3 < 10){//b
        console.log('Element3 is ' + ele3);
        setBlackC(false)
        document.getElementById("musers1").classList.remove("fw-blue")
        document.getElementById("musers2").classList.remove("fw-blue")
        document.getElementById("musers3").classList.add("fw-blue")
        document.getElementById("musers4").classList.remove("fw-blue")
        document.getElementById("musers5").classList.remove("fw-blue")
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:rgba(255, 255, 255, 0.95); border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo-4ac.svg" alt="" style="max-width:140px; width:100%; class="imgLogo"  className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#fff";
      }else if(ele3>50 && ele3<60){ 
        setBlackC(true)
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:#161616; border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo_light.svg" alt="" class="imgLogo" style="max-width:140px; width:100%; className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#161616";
      }

      if(ele4 >= 0 && ele4 < 10){//negro
        console.log('Element4 is ' + ele4);
        setBlackC(true)
        document.getElementById("musers1").classList.remove("fw-blue")
        document.getElementById("musers2").classList.remove("fw-blue")
        document.getElementById("musers3").classList.remove("fw-blue")
        document.getElementById("musers4").classList.add("fw-blue")
        document.getElementById("musers5").classList.remove("fw-blue")
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:#161616; border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo_light.svg" alt="" class="imgLogo" style="max-width:140px; width:100%; className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#161616";
      }else if(ele4>50 && ele4<60){ 
        setBlackC(false)
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:rgba(255, 255, 255, 0.95); border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo-4ac.svg" alt="" style="max-width:140px; width:100%; class="imgLogo"  className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#fff";
      }

      let eleC = document.getElementById("contact").getBoundingClientRect().top;//N
      if(eleC >= 0 && eleC < 10){//negro
        console.log('Element is ' + "contact");
        setBlackC(true)
        document.getElementById("musers1").classList.remove("fw-blue")
        document.getElementById("musers2").classList.remove("fw-blue")
        document.getElementById("musers3").classList.remove("fw-blue")
        document.getElementById("musers4").classList.remove("fw-blue")
        document.getElementById("musers5").classList.add("fw-blue")
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:rgba(255, 255, 255, 0.95); border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo-4ac.svg" alt="" style="max-width:140px; width:100%; class="imgLogo"  className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#fff";
      }else if(eleC>50 && eleC<60){
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:#161616; border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo_light.svg" alt="" class="imgLogo" style="max-width:140px; width:100%; className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#161616";
      }
    }else if(ruta === "/company"){
      //COMPANY
      let ele1 = document.getElementById("business_about").getBoundingClientRect().top;//B
      let ele2 = document.getElementById("business_success_stories").getBoundingClientRect().top;//N  
      if(ele1 >= 0 && ele1 < 10){//blanco
        console.log('Element is ' + "business");
        setBlackC(false)
        document.getElementById("mcompany1").classList.add("fw-blue")
        document.getElementById("mcompany2").classList.remove("fw-blue")
        document.getElementById("mcompany3").classList.remove("fw-blue")
      }else if(ele1 > 10){
        setBlackC(true)
      }
      if(ele2 >= 0 && ele2 < 10){//negro
        console.log('Element is ' + "business2");
        setBlackC(true)
        document.getElementById("mcompany2").classList.add("fw-blue")
        document.getElementById("mcompany1").classList.remove("fw-blue")
        document.getElementById("mcompany3").classList.remove("fw-blue")
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:#161616; border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo_light.svg" alt="" class="imgLogo" style="max-width:140px; width:100%; className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#161616";
      }else if(ele2>50 && ele2<60){
        setBlackC(false)
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:rgba(255, 255, 255, 0.95); border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo-4ac.svg" alt="" style="max-width:140px; width:100%; class="imgLogo"  className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "white";
      }
      let eleC = document.getElementById("contact").getBoundingClientRect().top;//N
      if(eleC >= 0 && eleC < 10){//negro
        console.log('Element is ' + "contact");
        document.getElementById("mcompany3").classList.add("fw-blue")
        document.getElementById("mcompany2").classList.remove("fw-blue")
        document.getElementById("mcompany1").classList.remove("fw-blue")
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:rgba(255, 255, 255, 0.95); border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo-4ac.svg" alt="" style="max-width:140px; width:100%; class="imgLogo"  className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "white";
        setBlackC(true)
      }else if(eleC>50 && eleC<60){
        setBlackC(true)
        document.getElementById("logoImg").innerHTML= '<a className="navbar-brand" style="background-color:#161616; border-radius:5px; display:inline-block; padding:5px; z-index:5;" href="index"><img src="./img/logo_light.svg" alt="" class="imgLogo" style="max-width:140px; width:100%; className="imgLogo"/></a>'
        document.getElementById("socialButton").style.backgroundColor= "#161616";
      }
    }else{
      console.log("inicio");
    }
  });

    return (
      <Fragment>
        <header className="topFixed" id="head-container">
            <Row style={{height:"100px"}}>
              <Col xs={6} md={8} style={{height:"100px"}}>
                <Row>
                  <Col xs={12} md={3} id="logoImg" style={{maxWidth:"180px"}}>
                    <a className="navbar-brand" href="index">
                      <img src="./img/logo-4ac.svg" alt="" style={{maxWidth:"140px", width:"100%"}} className="imgLogo"/>
                    </a>
                  </Col>
                  <Col xs={12} md={8} >
                    <div className="social-button hide show-inline middle" id="socialButton">
                      <div className="dis-inline-block middle ">
                        <p className=" fs-12 fw-bold c-blue txt-uppercase letter-spacing-3px">
                          Follow us
                        </p>
                      </div>
                      <div className="dis-inline-block middle margenF">
                        <a href="https://twitter.com/Dicio_AI" target="_blank" className="dis-inline-block middle pad-all-5">
                          <i className="fab fa-twitter"></i>
                        </a>

                        <a href="https://www.facebook.com/Dicioai/" target="_blank" className="dis-inline-block middle pad-all-5">
                          <i className="fab fa-facebook-f"></i>
                        </a>

                        
                        <a href="https://www.linkedin.com/company/dicio-ai/about/" target="_blank" className="dis-inline-block middle pad-all-5">
                          <i className="fab fa-linkedin-in"></i>
                        </a>

                        <a href="https://www.instagram.com/dicio.ai/" target="_blank" className="dis-inline-block middle pad-all-5">
                          <i className="fab fa-instagram"></i>
                        </a>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={6} md={4}>
                <Navbar expand="lg" className="fullW flex-column align-items-end custom-toggler">
                  <Navbar.Toggle aria-controls="basic-navbar-nav" style={{border:"0"}} className="c-black"/>
                  <Navbar.Collapse id="basic-navbar-nav" >
                  <Nav className="mr-auto" defaultActiveKey="/index" className="fullW flex-column align-items-end" style={{padding:"0"}}>
                    <Nav.Link href="/we" id="twe" className={(blackC) ? "titleMenuW" : "titleMenu"} >WE</Nav.Link>
                    <ul id="mwe" className={(ruta === "/we") ? "siVisible": "noVisible"} style={{marginBottom:"5px"}}>
                      <li id="mwe1"><Nav.Link href="#dicio-about" className={(ruta==="/we") ? (blackC) ? "titleSubWA" : "titleSubA" : (blackC) ? "titleSubW" : "titleSub"}>What is DICIO?</Nav.Link></li>
                      <li id="mwe2"><Nav.Link href="#dicio-business" className={(ruta==="/we") ? (blackC) ? "titleSubWA" : "titleSubA" : (blackC) ? "titleSubW" : "titleSub"} style={{padding:"0 .5rem"}}>Our alies</Nav.Link></li>
                      <li id="mwe3"><Nav.Link href="#dicio-team" className={(ruta==="/we") ? (blackC) ? "titleSubWA" : "titleSubA" : (blackC) ? "titleSubW" : "titleSub"}>Team</Nav.Link></li>
                      <li id="mwe4"><Nav.Link href="#contact" className={(ruta==="/we") ? (blackC) ? "titleSubWA" : "titleSubA" : (blackC) ? "titleSubW" : "titleSub" } style={{padding:"0 .5rem"}}>Contact</Nav.Link></li>
                    </ul>
                    <Nav.Link href="/users" id="tusers" className={(ruta==="/users") ? (blackC) ? "titleMenuWA" : "titleMenuA" : (blackC) ? "titleMenuW" : "titleMenu"}>USERS</Nav.Link>
                    <ul id="musers" className={(ruta === "/users") ? "siVisible": "noVisible"} style={{marginBottom:"5px"}}>
                      <li id="musers1"><Nav.Link href="#users-features" className={(ruta==="/users") ? (blackC) ? "titleSubWA" : "titleSubA" : (blackC) ? "titleSubW" : "titleSub"}>Why use DICIO?</Nav.Link></li>
                      <li id="musers2"><Nav.Link href="#users-about" className={(ruta==="/users") ? (blackC) ? "titleSubWA" : "titleSubA" : (blackC) ? "titleSubW" : "titleSub"} style={{padding:"0 .5rem"}}>How  it works?</Nav.Link></li>
                      <li id="musers3"><Nav.Link href="#users-testimonial" className={(ruta==="/users") ? (blackC) ? "titleSubWA" : "titleSubA" : (blackC) ? "titleSubW" : "titleSub"}>Testimonials</Nav.Link></li>
                      <li id="musers4"><Nav.Link href="#users-appContainer" className={(ruta==="/users") ? (blackC) ? "titleSubWA" : "titleSubA" : (blackC) ? "titleSubW" : "titleSub"} style={{padding:"0 .5rem"}}>App</Nav.Link></li>
                      <li id="musers5"><Nav.Link href="#contact" className={(ruta==="/users") ? (blackC) ? "titleSubWA" : "titleSubA" : (blackC) ? "titleSubW" : "titleSub"}>Contact</Nav.Link></li>
                    </ul>
                    <Nav.Link href="/company" id="tcompany" className={(ruta==="/company") ? (blackC) ? "titleMenuWA" : "titleMenuA" : (blackC) ? "titleMenuW" : "titleMenu"}>COMPANY</Nav.Link>
                    <ul id="mcompany" className={(ruta === "/company") ? "siVisible": "noVisible"} >
                      <li id="mcompany1"><Nav.Link href="#business_about" className={(ruta==="/company") ? (blackC) ? "titleSubWA" : "titleSubA" : (blackC) ? "titleSubW" : "titleSub"}>Benefits of DICIO</Nav.Link></li>
                      <li id="mcompany2"><Nav.Link href="#business_success_stories" className={(ruta==="/company") ? (blackC) ? "titleSubWA" : "titleSubA" : (blackC) ? "titleSubW" : "titleSub"} style={{padding:"0 .5rem"}}>Success stories</Nav.Link></li>
                      <li id="mcompany3"><Nav.Link href="#contact" className={(ruta==="/company") ? (blackC) ? "titleSubWA" : "titleSubA" : (blackC) ? "titleSubW" : "titleSub"}>Contact</Nav.Link></li>
                    </ul>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
              </Col>
            </Row>
          </header>
      </Fragment>
    );
}
export default Header;